import React from "react";

/* Organic rounded shape */
export const OrgShape = ({ className, color, style }: { className?: string; color: string; style?: React.CSSProperties }) => (
  <div
    className={`pointer-events-none absolute ${className}`}
    style={{
      background: color,
      borderRadius: "42% 58% 55% 45% / 48% 42% 58% 52%",
      ...style,
    }}
  />
);

/* Wavy dot ribbon */
export const WavyDots = ({
  className,
  color,
  rows = 4,
  cols = 10,
  amplitude = 10,
}: {
  className?: string;
  color: string;
  rows?: number;
  cols?: number;
  amplitude?: number;
}) => {
  const spacing = 16;
  const width = cols * spacing + 24;
  const height = rows * spacing + amplitude * 2 + 20;

  return (
    <svg className={`pointer-events-none absolute ${className}`} viewBox={`0 0 ${width} ${height}`} fill="none" aria-hidden="true">
      {Array.from({ length: rows }).flatMap((_, row) =>
        Array.from({ length: cols }).map((_, col) => {
          const offsetX = row * 6;
          const x = 12 + col * spacing + offsetX;
          const progress = col / Math.max(cols - 1, 1);
          const y = 10 + row * spacing + Math.sin(progress * Math.PI) * amplitude;
          // Fade size at edges for a natural ribbon look
          const edgeFade = Math.sin(progress * Math.PI);
          const baseR = 3.4 - row * 0.3;
          const r = Math.max(baseR * (0.5 + edgeFade * 0.5), 1.2);
          const opacity = 0.4 + edgeFade * 0.6;
          return <circle key={`${row}-${col}`} cx={x} cy={y} r={r} fill={color} opacity={opacity} />;
        })
      )}
    </svg>
  );
};

/* Shared page background decorations */
export const PageDecorations = () => (
  <>
    <OrgShape
      className="-top-20 -right-16 h-[350px] w-[380px]"
      color="radial-gradient(circle at 35% 40%, hsla(42,94%,84%,0.98) 0%, hsla(41,90%,66%,0.82) 62%, hsla(41,88%,58%,0) 100%)"
      style={{ borderRadius: "55% 45% 48% 52% / 42% 55% 45% 58%" }}
    />
    <svg className="pointer-events-none absolute -left-10 bottom-[18%] h-16 w-16 lg:h-28 lg:w-28" viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <path
        d="M50,90 C50,90 10,60 10,35 C10,20 22,8 36,8 C44,8 50,14 50,14 C50,14 56,8 64,8 C78,8 90,20 90,35 C90,60 50,90 50,90Z"
        fill="hsla(0,0%,100%,0.45)"
      />
    </svg>
  </>
);
